export const availableNoCodeLanguages = ['en', 'sv', 'fi', 'da', 'no'] as const;

export type NoCodeSupportedLanguage = (typeof availableNoCodeLanguages)[number];
